import React from 'react'
import styled from 'styled-components'

import {Text} from '@/components/text'
import {focusStyles} from '@/styles/utils'
import {tokens, radii, colors} from '@/theme'

import type {BackgroundColor} from '@/utils/is-valid-background-color'

interface Props {
    title: string
    description: string
    category?: string
    labelColor: BackgroundColor
    Image: () => React.JSX.Element
    CTA: (props: any) => React.JSX.Element
}

export const LabelCard = ({title, description, category, labelColor, Image, CTA}: Props) => (
    <Card as={CTA}>
        <Image />

        <CopyWrapper>
            <Text>{title}</Text>
            <Text $variant="paragraph-base">{description}</Text>
        </CopyWrapper>

        <Label $variant="label-base" $backgroundColor={colors.background[labelColor]}>
            {category}
        </Label>
    </Card>
)

const Card = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${tokens.spacing20};

    &:focus-visible {
        ${focusStyles()}
        border-radius: ${({theme}) => theme.radii.arc4};
    }
`

const Label = styled(Text)<{$backgroundColor: string}>`
    background-color: ${(props) => props.$backgroundColor};
    width: max-content;
    border-radius: ${radii.arc4};
    padding: ${tokens.spacing4} ${tokens.spacing8};
`

const CopyWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${tokens.spacing4};
    flex: 1;
`
